import React from 'react';
import DatePicker from 'react-datepicker';

const LastConsultFields = ({ formData, handleChange }) => {
  const handleDateChange = date => {
    if (date)
      handleChange({ last_consult_date: date });
    else
      handleChange({ last_consult_date: null, last_consult_same_provider: false });
  };

  return (
    <React.Fragment>
      <h4>Previous consultations of the patient in the same specialty</h4>
      <p>
        The last consultation date is required to simulate a followup visit.
        Leave blank if you want to simulate an initial consultation.
      </p>
      <table className="fields">
        <tbody>
          <tr>
            <th><label htmlFor="last_consult_date">Last consultation date</label></th>
            <td>
              <DatePicker
                name="last_consult_date"
                isClearable
                selected={formData.last_consult_date}
                onChange={handleDateChange}
                maxDate={new Date()}
                dateFormat="MMMM d, yyyy"
              />
            </td>
          </tr>
          <tr>
            <th><label htmlFor="last_consult_same_provider">Same provider</label></th>
            <td>
              <input
                type="checkbox"
                name="last_consult_same_provider"
                checked={formData.last_consult_same_provider}
                disabled={!formData.last_consult_date}
                onChange={(e) => handleChange({ last_consult_same_provider: e.target.checked })}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default LastConsultFields;
